import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
      {/* Nav section  */}
      <section className="footer-sec">
        <div className="container">
          <div className="row">
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <div className="nav-all">
                <ul>
                  <li>
                    <Link to="/Home">HOME</Link>
                  </li>
                  <li>
                    <Link to="/About">ABOUT</Link>
                  </li>
                  <li>
                    <Link to="/">ROADMAP</Link>
                  </li>

                  {/* <li>
                    <Link to="/">MEET THE CREATORS</Link>
                  </li> */}

                  <li>
                    <Link to="/Whitepaper">WHITEPAPER</Link>
                  </li>
                  {/* <li>
                    <Link to="/">GOD-VERSE</Link>
                  </li> */}
                  {/* <li>
                    <Link to="/">MINT</Link>
                  </li> */}
                  {/* <li className="no-border">
                    <Link to="/Faq">FAQ</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright">
          <p>© Copyright NFT WEBSITE 2022. All Right Reserved.</p>
        </div>
      </section>
      {/* End of Nav section  */}
    </>
  );
};

export default Footer;
